const PARENT_CLASS_NAME = 'vxo-no-scroll';
//TOOD - Need to split into util files
const VCOPUtils = {
  close(wrapperId) {
    const wrapper = document.getElementById(wrapperId);
    if (wrapper && wrapper.parentElement === document.body) {
      document.body.removeChild(wrapper);
    }
  },

  createIFrame: (name, wrapperId, frameId, onLoad) => {
    const wrapper = document.createElement('div');
    const iFrame = document.createElement('iframe');
    const wrapperProps = {
      visibility: '',
      width: '100%',
      height: '100%', // eslint-disable-line
      position: 'fixed',
      top: 0,
      left: 0, // eslint-disable-line
      zIndex: 1000000 // is one higher than RXO so RXO will be hidden while loading
    };

    iFrame.frameBorder = 0;
    iFrame.title = name;
    iFrame.id = frameId;
    iFrame.className = frameId;
    iFrame.style.height = '100%';
    iFrame.style.width = '100%';
    iFrame.style.display = 'block';
    iFrame.onload = onLoad;

    wrapper.id = wrapperId;
    wrapper.name = name;
    wrapper.appendChild(iFrame);

    VCOPUtils.lockParentScroll(wrapper, PARENT_CLASS_NAME);

    for (const prop in wrapperProps) {
      if (wrapperProps.hasOwnProperty(prop)) {
        wrapper.style[prop] = wrapperProps[prop];
      }
    }

    return wrapper;
  },

  createIFrameStyle: frameId => {
    let styleElement;

    const cssText = `#${frameId}.${frameId}{height: 100%; /*height: 100vh;*/ width: 100%; width: 100vw;} body.pay-selector {overflow:hidden;}`;
    styleElement = document.createElement('style'); // eslint-disable-line
    styleElement.type = 'text/css';

    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = cssText;
    } else {
      styleElement.appendChild(document.createTextNode(cssText));
    }

    return styleElement;
  },

  lockParentScroll: (target, parentClassName) => {
    const noScrollCSS = `body.${parentClassName}{overflow:hidden !important; position: fixed; width: 100%; height:100%;}`;
    const styleElement = document.createElement('style');

    styleElement.type = 'text/css';

    if (styleElement.styleSheet) {
      styleElement.styleSheet.cssText = noScrollCSS;
    } else {
      styleElement.appendChild(document.createTextNode(noScrollCSS));
    }

    target.appendChild(styleElement);
    //SDKUtils.addClass(document.body, parentClassName);
  }
};

export default VCOPUtils;
